import { useQuery } from "@tanstack/react-query";
import { creditsApi } from "@pracownik/sdk-web";
import { queryKeys } from "@/lib/query-keys";

export function useCredits() {
  return useQuery({
    queryKey: queryKeys.credits.balance,
    queryFn: () => creditsApi.getBalance(),
    refetchInterval: 30 * 1000, // Poll every 30s
  });
}
